import { createUserManager } from 'redux-oidc';

const userManagerConfig = {
  client_id: process.env.REACT_APP_IDENTITY_CLIENT_ID,
  redirect_uri: process.env.REACT_APP_REDIRECT_URL,
  response_type: 'code',
  scope: 'openid profile GatewayMDA',
  authority: process.env.REACT_APP_AUTH_URL,
  silent_redirect_uri: process.env.REACT_APP_SILENT_REDIRECT_URL,
  post_logout_redirect_uri: process.env.POST_LOGOUT_REDIRECT_URI,
  automaticSilentRenew: true,
  filterProtocolClaims: true,
  loadUserInfo: true,
  monitorSession: true,
};

const userMfaManagerConfig = {
  authority: process.env.REACT_APP_MFA_AUTH_URL,
  client_id: process.env.REACT_APP_MFA_CLIENT_ID,
  redirect_uri: `${window.location.origin}/popupCallback.html`,
  response_type: 'code',
  scope: 'openid profile allowedrisk:high',
  popup_redirect_uri: `${window.location.origin}/popupCallback.html`,
  filterProtocolClaims: false,
  loadUserInfo: false,
  extraQueryParams: {
    audience: 'https://api.wealtho2.com.au/',
  },
};

export const userManager = createUserManager(userManagerConfig);
export const userMfaManager = createUserManager(userMfaManagerConfig);
